<!-- ------------------Hero Section------------ -->
<div class="softwaredev-section-bg">
    <section class="softwaredev-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-5">
                    <h1 class="softwaredev-heading mb-3">
                        UI/UX Design Services for Seamless User Journeys and Measurable Growth
                    </h1>
                    <!-- <p class="softwaredev-subheading1 mb-4">
                        Powered by AI
                    </p> -->
                    <p class="softwaredev-subheading2 mb-4">
                        Get seamless, user-focused interfaces that enhance your engagement, reduce friction, and boost
                        conversions, designed by our certified UI/UX experts.
                    </p>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="getAFreeQuote()">
                            Get a Free Quote
                        </button>
                    </div>
                </div>

                <div class="col-lg-7 text-center">
                    <video #heroVideo preload="auto" src="../../../../assets/services/uiux/ui-ux-video.webm"
                        class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- ============== SERVICE OVERVIEW SECTION ================ -->
<!-- <section class="service-overview-section">
    <div class="container">
        <div class="row align-items-center">

            <div class="col-lg-5">
                <h2 class="overview-heading">Service Overview</h2>
                <p class="overview-text">
                    At Kalpita Technologies, our software development services are designed to help businesses scale smarter, innovate faster, and stay ahead of the curve. We build solutions that are not only reliable and secure but also tailored to your unique business goals.
                </p>
                <p class="overview-text">
                    Whether you need a customer-facing application, an enterprise platform, or cloud-native solutions, our team ensures seamless integration, future-ready architecture, and measurable business impact.
                </p>
            </div>

            <div class="col-lg-7">
                <div class="service-display-wrapper">
             
                    <div class="background-shape"></div>
                 
                    <div class="arc-path"></div>
              
                    <div class="center-graphic">
                        <img src="https://i.ibb.co/wJb20YV/center-graphic.png" alt="Core Technology">
                    </div>
                    <div class="service-points-container">
                        <div *ngFor="let service of services; let i = index" 
                             class="service-point"
                             [ngClass]="{ 'active': i === selectedServiceIndex }"
                             [style.transform]="getPointTransform(i)"
                             (click)="selectService(i)">
                            
                            <div class="icon">
                 
                                <img *ngIf="i === selectedServiceIndex" [src]="service.icon" class="active-icon-graphic" [alt]="service.title">
                            </div>
                            <div class="label">{{ service.title }}</div>
                        </div>
                    </div>

                    <div class="active-service-details" [attr.key]="selectedServiceIndex">
                         <h3 class="active-title">{{ services[selectedServiceIndex].title }}</h3>
                         <p class="active-description">{{ services[selectedServiceIndex].description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- ============== CUSTOM SOFTWARE DEVELOPMENT PROCESS ================ -->
<section class="dev-process-section">
    <div class="container">
        <!-- Section Header -->
        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-9">
                <h2 class="section-heading-process">Our Proven 5-Step UI/UX Design Process for Outstanding User
                    Experience</h2>
                <p class="section-subheading-process mt-3">Our process is built on collaboration, research, and
                    iteration, ensuring your design isn’t just beautiful, but functional and business driven.</p>
            </div>
        </div>

        <!-- Process Cards Container -->
        <div class="process-cards-container">
            <div class="process-card" *ngFor="let step of developmentProcess; let i = index"
                [ngClass]="{ 'card-blue': i % 2 === 0, 'card-white': i % 2 !== 0 }">

                <div class="process-icon-wrapper">
                    <img [src]="step.icon" [alt]="step.title" class="process-icon">
                </div>

                <h3 class="process-title">{{ step.title }}</h3>
                <p class="process-description">{{ step.description }}</p>
            </div>
        </div>
    </div>
</section>
<!-- =================== WHY CHOOSE US SECTION =================== -->
<!-- ADDED: Template Reference & Animation Class Binding -->
<section class="why-choose-us-section py-5" #whyChooseSection [class.start-animation]="isWhyChooseVisible">
    <div class="container">
        <!-- Section Header -->
        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Why Choose Kalpita for Your Business’ UI/UX Design</h2>
                <p class="section-subheading mt-3">Our UI/UX experts blend creativity with data-driven insights to
                    design interfaces that not only look exceptional but also perform seamlessly.</p>
            </div>
        </div>
        <!-- Features Grid -->
        <div class="row g-4">
            <!-- Left Column: Takes the first half of the array -->
            <div class="col-lg-6 d-flex flex-column">
                <div class="feature-card flex-grow-1 mb-4"
                    *ngFor="let item of whyChooseFeatures.slice(0, whyChooseFeatures.length / 2)">
                    <!-- The simple icon container -->
                    <div class="icon-container">
                        <img [src]="item.icon" [alt]="item.title" class="icon-image">
                    </div>
                    <!-- The text content -->
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-description">{{ item.description }}</p>
                    </div>
                </div>
            </div>

            <!-- Right Column: Takes the second half of the array -->
            <div class="col-lg-6 d-flex flex-column">
                <div class="feature-card flex-grow-1 mb-4"
                    *ngFor="let item of whyChooseFeatures.slice(whyChooseFeatures.length / 2, whyChooseFeatures.length)">
                    <!-- The simple icon container -->
                    <div class="icon-container">
                        <img [src]="item.icon" [alt]="item.title" class="icon-image">
                    </div>
                    <!-- The text content -->
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-description">{{ item.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- =================== FEATURES & INCLUSIONS SECTION =================== -->
<div class="features-inclusion-bg">
    <!-- ADDED: Template Reference & Animation Class Binding -->
    <section class="features-section container py-5" #featuresSection [class.start-animation]="isFeaturesVisible">
        <!-- Centered Header -->
        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-10">
                <h2 class="features-heading">Our Comprehensive UI/UX Design Services Include</h2>
            </div>
        </div>

        <div class="row align-items-center">
            <!-- Left Column: Features List -->
            <div class="col-lg-6">
                <div class="features-list-wrapper">
                    <!-- <p>Our custom web development services include, </p> -->
                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">User Research & Persona Development</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Wireframing & Prototyping</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Interaction Design & Motion Graphics</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Mobile App UI/UX Design (iOS & Android)</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Web & Dashboard UI Design</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Product Redesign & Usability Audit</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">UX Writing & Accessibility Design (WCAG Compliant)</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Cross-platform Interface Optimization</p>
                    </div>

                </div>
            </div>

            <!-- Right Column: Image -->
            <div class="col-lg-6 d-flex justify-content-center">
                <div class="features-image-wrapper">
                    <!-- Update this path to your specific feature image -->
                    <img src="../../../../assets/services/uiux/features-img.png" alt="Software Development Features"
                        class="img-fluid features-img">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Technologies Section -->
<app-suite-technologies></app-suite-technologies>
<!-- =================== SUCCESS STORIES SECTION =================== -->
<section class="success-stories-section py-5">
    <div class="container">
        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Success Stories</h2>
                <!-- <p class="section-subheading mt-3">Here are some real-world results from our clients:</p> -->
            </div>
        </div>
    </div>
    <div class="timeline-container">
        <div class="timeline-wrapper">
            <div class="content-layout">
                <!-- Cards Stack -->
                <div class="cards-stack">
                    <div *ngFor="let item of visibleCards" class="card-wrapper"
                        [class.card-top]="item.position === 'top'" [class.card-center]="item.position === 'center'"
                        [class.card-bottom]="item.position === 'bottom'" (click)="selectCard(item.position)">

                        <div class="card">
                            <div class="card-image">
                                <img [src]="item.card.image" [alt]="item.card.title">
                                <div class="card-overlay"></div>
                            </div>

                            <div class="card-badge" *ngIf="item.position === 'center'">
                                <span class="year-badge">{{ item.card.year }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Text Content - Only shows for center card -->
                <div class="text-content">
                    <!-- Check if cards array is not empty before accessing -->
                    <ng-container *ngIf="timelinecards.length > 0 && timelinecards[selectedIndex]">
                        <h2 class="content-year">{{ timelinecards[selectedIndex].title }}</h2>
                        <p class="content-description">{{ timelinecards[selectedIndex].description }}</p>
                    </ng-container>
                </div>

                <!-- Vertical Carousel Dots -->
                <div class="carousel-dots-vertical" *ngIf="showCarouselDots">
                    <button *ngFor="let card of timelinecards; let i = index" class="dot"
                        [class.active]="i === selectedIndex" (click)="goToCard(i)"
                        [attr.aria-label]="'Go to ' + card.year">
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- FAQ -->
<app-faq [faqList]="uiuxFaqs"></app-faq>
<!-- Final CTA -->
<div class="final-cta-bg">
    <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule"
        class="cta-capsule-img">
    <section id="final-cta" class="final-cta-section container">
        <div class="section-header text-center mx-auto">
            <!-- <h2>Final CTA</h2> -->
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6 cta-content-col">
                <h2 class="cta-heading-small">Ready to Elevate Your Digital Experience?</h2>
                <p style="color: #ffffff;" class="cta-subheading mb-4">Let’s design interfaces your users will love, and your business will grow
                    from.</p>
                <!-- <h1 class="cta-heading-large mb-3">Health Care Industry?</h1>
        <p class="cta-subheading mb-4">
          Let’s build software that’s made for YOU, not everyone else. 
        </p> -->
                <div class="mb-5 cta-btn-group">
                    <button class="btn btn-schedule-demo" (click)="bookAFreeCall()">
                        Book Your Free UI/UX Design Consultation
                    </button>
                </div>
            </div>
            <div class="col-lg-6 text-center">
                <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
                    class="img-fluid cta-clinic-image">
            </div>
        </div>
    </section>
</div>
<!-- Explore More Services -->
<app-explore-more-services></app-explore-more-services>